var Vagas = function(){

	var page = $('[data-page="vagas"]');

	this.init = function(){

		if($(window).width() > 768){
			blocksPosition();
		}

	}

	function blocksPosition(){
		page.find('.list').masonry({
			horizontalOrder: true
		});
	}

	return this.init();

}
